<template>
  <div>
    <v-row class="customer-detail custom-border-to">
      <v-col md="12" sm="12" class="pt-0">
        <!-- Loader -->
        <v-skeleton-loader
          class="custom-skeleton"
          v-if="pageLoading"
          type="table-tbody"
        />

        <!-- Table -->
        <v-simple-table v-else class="simple-table">
          <template v-slot:default>
            <!-- HEADER -->
            <thead>
              <tr style="background-color: #f3f6f9; color: #24326d">
                <th class="simple-table-th">Customer</th>
                <th class="simple-table-th">Price</th>
                <th class="simple-table-th">Modified At</th>
                <th class="simple-table-th">Added Date</th>
                <th class="simple-table-th">Action</th>
              </tr>
            </thead>

            <!-- BODY -->
            <tbody>
              <tr
                v-for="(item, index) in rowData"
                :key="index"
                :class="{
                  'custom-border-top': index == 0,
                  'orange_lighten-5': index % 2 == 0,
                }"
              >
                <!-- Product Name -->
                <td class="font-size-14 font-weight-500">
                  {{ item.customer_rel?.display_name }}
                </td>

                <!-- Price -->
                <td class="font-size-14 font-weight-500">
                  $ {{ Number(item?.price) ?? "0.00" }}
                </td>

                <td class="font-size-14 font-weight-500">
                  <template v-if="item.updated_at">
                    {{ formatDateTime(item.updated_at) }}
                  </template>
                  <em v-else class="text-muted"> no modification date </em>
                </td>
                <!-- Date -->
                <td class="font-size-14 font-weight-500">
                  <template v-if="item.added_at">
                    {{ formatDateTime(item.added_at) }}
                  </template>
                  <em v-else class="text-muted"> no added date </em>
                </td>
                <td class="font-size-14 font-weight-500">
                  <v-btn
                    icon
                    small
                    color="cyan"
                    @click="$emit('edit-product', item)"
                  >
                    <v-icon small>mdi-pencil</v-icon>
                  </v-btn>
                  <v-btn icon small color="red" @click="openDeleteDialog(item)">
                    <v-icon small>mdi-delete</v-icon>
                  </v-btn>
                </td>
              </tr>

              <!-- EMPTY -->
              <tr v-if="rowData.length === 0">
                <td colspan="6" class="text-center py-4">
                  <img
                    :src="$assetURL('media/error/empty.png')"
                    class="row-not-found-image"
                  />
                  <em class="text-muted"> No customers found. </em>
                </td>
              </tr>
              <Dialog :common-dialog="action_dialog">
                <template v-slot:title> Confirmation </template>

                <template v-slot:body>
                  <v-form ref="form" v-model="formValid">
                    <v-container>
                      <p class="font-size-19 font-weight-600 mx-2 my-0">
                        Are you sure, you want to delete this Customer?
                      </p>
                    </v-container>
                  </v-form>
                </template>

                <template v-slot:action>
                  <v-btn
                    depressed
                    class="mx-2 custom-bold-button white--text"
                    color="red"
                    @click="action_submit"
                    :loading="formLoading"
                  >
                    Delete
                  </v-btn>

                  <v-btn
                    depressed
                    :disabled="formLoading"
                    class="mx-2 custom-grey-border custom-bold-button"
                    @click="action_dialog = false"
                  >
                    Cancel
                  </v-btn>
                </template>
              </Dialog>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import CommonMixin from "@/core/plugins/common-mixin";
import { DELETE } from "@/core/services/store/request.module";
import Dialog from "@/view/pages/partials/Dialog.vue";
export default {
  name: "ProductDetail",
  mixins: [CommonMixin],

  props: {
    customers: {
      type: Array,
      default: () => [],
    },
    pageLoading: {
      type: Boolean,
      default: false,
    },
    source: {
      type: String,
      default: "product",
    },
  },
  components: {
    Dialog,
  },

  data() {
    return {
      rowData: [],
      action_dialog: false,
      selected_customer: null,
      formLoading: false,
    };
  },

  watch: {
    customers: {
      deep: true,
      immediate: true,
      handler() {
        this.assignData();
      },
    },
  },

  methods: {
    action_submit() {
      if (!this.selected_customer) return;

      this.formLoading = true;

      this.$store
        .dispatch(DELETE, {
          url: `customer-${this.source === "service" ? "sor" : "product"}/${
            this.selected_customer.id
          }`,
          data: { source: this.source },
        })
        .then(() => {
          this.action_dialog = false;
          this.selected_customer = null;
          this.$emit("refresh");
        })
        .catch((err) => {
          this.logError(err);
        })
        .finally(() => {
          this.formLoading = false;
          this.action_dialog = false;
          this.$emit("refresh");
        });
    },
    assignData() {
      if (this.customers && this.customers.length) {
        this.rowData = this.customers.map((item) => {
          return {
            ...item,
            customer: parseInt(item.customer),
          };
        });
      } else {
        this.rowData = [];
      }
    },
    openDeleteDialog(item) {
      this.selected_customer = item;
      this.action_dialog = true;
    },
  },
  mounted() {
    this.assignData();
  },
};
</script>
